export default timetableService => {
    return function (input, key, filters) {

        var hour = filters[key].hour,
            type = filters[key].type,
            c,
            i,
            j,
            m,
            l = input.length;

        if (hour === null || type === null || type === 'Show all') {
            for (i = 0; i < l; i++) {
                m = input[i].classes;
                for (j = 0; j < m.length; j++) {
                    m[j].timeFilter = true;
                }

                input[i] = timetableService.checkForVisibleChildren(input[i], filters);
            }
        } else {
            for (i = 0; i < l; i++) {
                m = input[i].classes;
                for (j = 0; j < m.length; j++) {
                    c = m[j];
                    c.timeFilter = false;

                    if (c.meetingStartTime !== undefined && c.meetingStartTime !== null) {

                        if (type === 'Starting after') {
                            if (hour &&
                                parseInt(c.meetingStartTime.replace(':', '')) >=
                                parseInt(hour.replace(':', ''))) {
                                c.timeFilter = true;
                            }
                        } else if (type === 'Finishing before') {
                            if (hour &&
                                parseInt(c.meetingEndTime.replace(':', '')) <=
                                parseInt(hour.replace(':', ''))) {
                                c.timeFilter = true;
                            }
                        }
                    }
                }

                input[i] = timetableService.checkForVisibleChildren(input[i], filters);
            }
        }
        return input;
    }
};